<h2 mat-dialog-title i18n>Assign permission to: {{ form().title }}</h2>
<!--  -->
<mat-dialog-content>
  <div class="app-form-loader-div">
    <mat-slide-toggle
      [checked]="showOnlyActive()"
      (change)="onShowOnlyActiveChange($event)"
    >
      @if (showOnlyActive()) {
        <span i18n>Active forms</span>
      }
      @if (!showOnlyActive()) {
        <span i18n>All forms</span>
      }
    </mat-slide-toggle>
    <app-form-loader [showOnlyActive]="showOnlyActive()"
      [loadOnSelectionChange]="true"
      [appearance]="'outline'"
      (formSelected)="onFormSelected($event)"
      (emitLoading)="formIsLoading($event)"
     />
  </div>
  <div class="flex-col gap-9">
    <div class="permissions-container">
      @if (isLoading()) {
        <mat-progress-bar mode="indeterminate" />
      } @else {
        <mat-accordion multi>
          @if (parsedEdit().included.length || parsedEdit().excluded.length) {
            <mat-expansion-panel expanded>
              <mat-expansion-panel-header>
                <mat-panel-title i18n="@@editPermList"> Edit </mat-panel-title>
                <mat-panel-description i18n="@@listOfPermIncludExclud">
                  list of included and excluded permissions
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="expansion-content">
                @if (parsedEdit().included.length) {
                  <div class="chip-section">
                    <span class="section-label success" i18n="@@included:">
                      Included:</span
                    >
                    <mat-chip-set class="custom-chip-set">
                      @for (item of parsedEdit().included; track item.raw) {
                        <mat-chip class="included-chip">
                          <strong>{{ item.type }}</strong> | {{ item.name }}
                        </mat-chip>
                      }
                    </mat-chip-set>
                  </div>
                }

                @if (parsedEdit().excluded.length) {
                  <div class="chip-section">
                    <span class="section-label warn" i18n="@@excluded:">
                      Excluded:</span
                    >
                    <mat-chip-set class="custom-chip-set">
                      @for (item of parsedEdit().excluded; track item.raw) {
                        <mat-chip class="excluded-chip">
                          <strong>{{ item.type }}</strong> | {{ item.name }}
                        </mat-chip>
                      }
                    </mat-chip-set>
                  </div>
                }
              </div>
            </mat-expansion-panel>
          }

          @if (parsedSave().included.length || parsedSave().excluded.length) {
            <mat-expansion-panel expanded>
              <mat-expansion-panel-header>
                <mat-panel-title i18n="@@savePermList"> Save </mat-panel-title>
                <mat-panel-description i18n="@@listOfPermIncludExclud">
                  list of included and excluded permissions
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="expansion-content">
                @if (parsedSave().included.length) {
                  <div class="chip-section">
                    <span class="section-label success" i18n="@@included:">
                      Included:</span
                    >
                    <mat-chip-set class="custom-chip-set">
                      @for (item of parsedSave().included; track item.raw) {
                        <mat-chip class="included-chip">
                          <strong>{{ item.type }}</strong> | {{ item.name }}
                        </mat-chip>
                      }
                    </mat-chip-set>
                  </div>
                }

                @if (parsedSave().excluded.length) {
                  <div class="chip-section">
                    <span class="section-label warn" i18n="@@excluded:">
                      Excluded:</span
                    >
                    <mat-chip-set class="custom-chip-set">
                      @for (item of parsedSave().excluded; track item.raw) {
                        <mat-chip class="excluded-chip">
                          <strong>{{ item.type }}</strong> | {{ item.name }}
                        </mat-chip>
                      }
                    </mat-chip-set>
                  </div>
                }
              </div>
            </mat-expansion-panel>
          }
          @if (!rawPermissions() && formTemplate()) {
            <span class="text-center" i18n
              >The form does not have permissions</span
            >
          }
          @if (!formTemplate()) {
            <span class="text-center" i18n>No form has been selected</span>
          }
        </mat-accordion>
      }
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton="outlined" (click)="onCloseClick()" i18n="@@buttonCancel">
    Cancel
  </button>
  <button
    matButton="elevated"
    color="accent"
    (click)="onSave()"
    [disabled]="!rawPermissions()"
    i18n="@@buttonAssignPermissions"
  >
    Assign Permissions
  </button>
</mat-dialog-actions>
